import api from "@/api";

const namespaced = true;

const state = {
  exchangeRates: [],
  exchangeRatesDownload: {}
}

const getters = {
  exchangeRates: state => state.exchangeRates,
  exchangeRatesDownload: state => state.exchangeRatesDownload
}

const mutations = {
  SET_EXCHANGE_RATES: (state, payload) => {
    state.exchangeRates = payload;
  },
  SET_EXCHANGE_RATES_DOWNLOAD: (state, payload) => {
    state.exchangeRatesDownload = payload;
  }
}

const actions = {
  async fetchExchangeRates({ commit, rootGetters }, payload) {
    try {
      const filterConfig = rootGetters['Table/defaultConfig']
      const filter = {
        search: filterConfig.search,
        page: filterConfig.currentPage,
        limit: filterConfig.pageSize,
        ...payload
      }
      const { data } = await api.getExchangeRate(filter)

      if (data.error) {
        commit('SET_EXCHANGE_RATES', [])
        commit('Table/SET_TOTAL_DATA', 0, { root: true })
        commit('Table/SET_TOTAL_PAGE', 1, { root: true })
        return
      }

      commit('SET_EXCHANGE_RATES', data.data)
      commit('Table/SET_TOTAL_DATA', data.total, { root: true })
      commit('Table/SET_TOTAL_PAGE', data.pages, { root: true })
    } catch (error) {
      throw error;
    }
  },
  async fetchExchangeRatesForDuplicateCheck({}, { start_date, end_date }) {
    const { data } = await api.getExchangeRate({
      page: 1,
      limit: 1,
      start_date,
      end_date
    })
    if (data.error) {
      if (data.error.code === 40410) {
        return []
      } else {
        throw new Error(data.error.message || 'Failed to verify duplicate date')
      }
    }
    return data.data || []
  },
  async postExchangeRate({ commit }, payload) {
    try {
      await api.postExchangeRate(payload.form)
    } catch (error) {
      throw error;
    }
  },
  async putExchangeRate({ commit }, payload) {
    try {
      await api.putExchangeRate(payload.id, payload.form)
    } catch (error) {
      throw error;
    }
  },
  async downloadExchangeRates({ commit, rootGetters }, payload) {
    try {
      const filterConfig = rootGetters['Table/defaultConfig']
      const response = await api.getExchangeRateExcelDownload({
        search: filterConfig.search,
        ...payload
      })
      if (response) {
        commit('SET_EXCHANGE_RATES_DOWNLOAD', response)
      }
    } catch (error) {
      throw error;
    }
  },
  resetExchangeRatesDownload({ commit }) {
    commit('SET_EXCHANGE_RATES_DOWNLOAD', {})
  }
}

export default { namespaced, state, getters, mutations, actions }
